<script setup>
import { ref, computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useI18n } from 'vue-i18n'
import LanguageSwitcher from "@/components/LanguageSwitcher.vue"
import AppNavigation from "@/components/AppNavigation.vue"

const { t } = useI18n()
const leftDrawerOpen = ref(false)
const authStore = useAuthStore()
const user = computed(() => authStore.user)
const loggedIn = computed(() => !!authStore.token)
</script>

<template>
  <q-layout view="lHh Lpr lFf">
    <!-- Шапка с кнопкой меню и заголовком -->
    <q-header elevated class="bg-primary text-white">
      <q-toolbar>
        <q-btn flat dense round icon="menu" aria-label="Menu" @click="leftDrawerOpen = !leftDrawerOpen" />
        <q-toolbar-title>{{ t('about.title') }}</q-toolbar-title>
        <div v-if="loggedIn" class="q-ml-auto">
          <q-chip icon="person" color="white" text-color="primary">
            {{ user.name }} ({{ user.role }})
          </q-chip>
        </div>
        <LanguageSwitcher />
      </q-toolbar>
    </q-header>

    <!-- Боковое меню (drawer) -->
    <q-drawer v-model="leftDrawerOpen" show-if-above bordered class="bg-grey-1">
      <AppNavigation />
    </q-drawer>

    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<style scoped>
.q-chip {
  font-size: 12px;
}
</style>